"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useInView } from "motion/react";
import Link from "next/link";
import { useRef } from "react";
import { TextRoll } from "@/components/animations/text-roll";
import { Button } from "@/components/ui/button";
import { SPORTS_LIST } from "@/config/sports";
const FROST_MASK = "backdrop-blur-[12px] [-webkit-mask-composite:source-in] [mask-composite:intersect] [mask-image:linear-gradient(to_bottom,transparent,black_20px,black_calc(100%_-_20px),transparent),linear-gradient(to_right,transparent,black_32px,black_calc(100%_-_32px),transparent)]";
export function FinalCtaSection() {
  const $ = _c(16);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(ref, t0);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const selectedSports = SPORTS_LIST.slice(0, 12);
    const mobileSports = selectedSports.slice(0, 4);
    const positions = [{
      top: "10%",
      left: "5%",
      rotate: -15,
      size: 48,
      opacity: 0.25
    }, {
      top: "20%",
      left: "25%",
      rotate: 20,
      size: 64,
      opacity: 0.15
    }, {
      top: "15%",
      right: "15%",
      rotate: -10,
      size: 56,
      opacity: 0.3
    }, {
      top: "35%",
      right: "5%",
      rotate: 45,
      size: 40,
      opacity: 0.15
    }, {
      bottom: "25%",
      left: "10%",
      rotate: -25,
      size: 52,
      opacity: 0.25
    }, {
      bottom: "10%",
      left: "30%",
      rotate: 15,
      size: 48,
      opacity: 0.2
    }, {
      bottom: "15%",
      right: "25%",
      rotate: -30,
      size: 64,
      opacity: 0.3
    }, {
      bottom: "30%",
      right: "8%",
      rotate: 10,
      size: 44,
      opacity: 0.2
    }, {
      top: "40%",
      left: "8%",
      rotate: -5,
      size: 40,
      opacity: 0.15
    }, {
      top: "5%",
      right: "35%",
      rotate: 35,
      size: 50,
      opacity: 0.25
    }, {
      bottom: "5%",
      right: "45%",
      rotate: -15,
      size: 60,
      opacity: 0.2
    }, {
      bottom: "40%",
      left: "18%",
      rotate: 25,
      size: 46,
      opacity: 0.25
    }];
    const mobilePositions = [{
      top: "12%",
      left: "8%",
      rotate: -12,
      size: 34,
      opacity: 0.16
    }, {
      top: "14%",
      right: "9%",
      rotate: 16,
      size: 38,
      opacity: 0.14
    }, {
      bottom: "12%",
      left: "10%",
      rotate: 12,
      size: 36,
      opacity: 0.14
    }, {
      bottom: "14%",
      right: "11%",
      rotate: -16,
      size: 34,
      opacity: 0.16
    }];
    t4 = "section-spacing w-full";
    t3 = "px-4 sm:px-6 lg:px-8";
    t1 = "relative flex h-[320px] items-center justify-center overflow-hidden rounded-3xl border border-border bg-card md:h-[400px] dark:border-transparent dark:bg-muted/20";
    t2 = <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden md:hidden">{mobileSports.map((sport, index) => {
        const pos = mobilePositions[index % mobilePositions.length];
        const Icon = sport.icon;
        return <div key={sport.id} className="absolute text-foreground" style={{
          top: pos.top,
          left: pos.left,
          right: pos.right,
          bottom: pos.bottom,
          transform: `rotate(${pos.rotate}deg)`,
          opacity: pos.opacity
        }}><Icon size={pos.size} stroke={1.5} /></div>;
      })}</div>;
    t5 = <div className="pointer-events-none absolute inset-0 z-0 hidden overflow-hidden md:block">{selectedSports.map((sport_0, index_0) => {
        const pos_0 = positions[index_0 % positions.length];
        const Icon_0 = sport_0.icon;
        return <div key={sport_0.id} className="hover:!opacity-100 hover:![transform:rotate(0deg)_scale(1.2)] pointer-events-auto absolute cursor-pointer text-foreground transition-all duration-500 ease-out" style={{
          top: pos_0.top,
          left: pos_0.left,
          right: pos_0.right,
          bottom: pos_0.bottom,
          transform: `rotate(${pos_0.rotate}deg)`,
          opacity: pos_0.opacity
        }}><div className="animate-pulse" style={{
            animationDelay: `${index_0 * 150}ms`,
            animationDuration: `${2000 + index_0 % 4 * 500}ms`
          }}><Icon_0 size={pos_0.size} stroke={1.5} /></div></div>;
      })}</div>;
    t6 = <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-t from-card/80 via-transparent to-card/80 dark:from-background/20 dark:to-background/20" />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className={`pointer-events-none absolute -inset-x-10 -inset-y-4 -z-10 ${FROST_MASK}`} aria-hidden="true" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isInView) {
    t8 = <span className="relative inline-block">{t7}<h2 ref={ref} className="font-semibold text-3xl tracking-tight md:text-5xl">{isInView ? <TextRoll duration={0.6}>Ready to play?</TextRoll> : <span className="opacity-0">Ready to play?</span>}</h2></span>;
    $[8] = isInView;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="relative inline-block"><span className={`pointer-events-none absolute -inset-x-8 -inset-y-3 -z-10 ${FROST_MASK}`} aria-hidden="true" /><p className="text-pretty text-base text-muted-foreground md:text-xl">One profile, every tournament. Get started in under a minute.</p></span>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <div className="flex max-w-3xl flex-col items-center gap-4">{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="pointer-events-auto flex w-full justify-center"><Button asChild={true} size="lg" className="h-11 w-full px-6 font-semibold text-base sm:w-auto md:h-12 md:px-8"><Link href="/auth/login">Create Your Player Profile<HugeiconsIcon icon={ArrowRight01Icon} className="ml-2 h-5 w-5" /></Link></Button></div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10) {
    t12 = <section className={t4}><div className={t3}><div className={t1}>{t2}{t5}{t6}<div className="pointer-events-none relative z-20 flex w-full flex-col items-center justify-center gap-6 px-5 text-center text-foreground md:gap-8 md:px-6">{t10}{t11}</div></div></div></section>;
    $[14] = t10;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  return t12;
}